/**
 * @file saga.js
 * @author Fernando Ruano
 * @description Initialize general saga
 */

// Dependencies
import { all, fork } from 'redux-saga/effects';

// Stores
import { watchAuthSaga } from './stores/auth/saga';
import { watchUserSaga } from './stores/user/saga';
import { watchPatientSaga } from './stores/patient/saga';
import { watchBloodPressureSaga } from './stores/blood-pressure/saga';
import { watchGlucometrySaga } from './stores/glucometry/saga';
import { watchCalendarSaga } from './stores/calendar/saga';
import { watchProfileSaga } from './stores/profile/saga';
import { watchRoleSaga } from './stores/role/saga';
import { watchParameterSaga } from './stores/parameter/saga';
import { watchMedicalParameterSaga } from './stores/medical-parameter/saga';
import { watchMenuSaga } from './stores/menu/saga';
import { watchCountryUserRoleSaga } from './stores/country-user-role/saga';
import { watchComponentsStateSaga } from './stores/components-state/saga';
import { watchEducationalElementSaga } from './stores/educational-element/saga';
import { watchS3FileSaga } from './stores/s3-file/saga';
import { watchEducationalCategorySaga } from './stores/educational-category/saga';
import { watchPatientEventSaga } from './stores/patient-event/saga';
import { watchDashboardStaffSaga } from './stores/dashboard-staff/saga';
import { watchClinicPhonesSaga } from './stores/clinic-phones/saga';
import { watchAppointmentsZoomSaga } from './stores/appointments-zoom/saga';

export default function* root() {
  yield all([
    fork(watchAuthSaga),
    fork(watchUserSaga),
    fork(watchPatientSaga),
    fork(watchCalendarSaga),
    fork(watchRoleSaga),
    fork(watchParameterSaga),
    fork(watchMedicalParameterSaga),
    fork(watchMenuSaga),
    fork(watchProfileSaga),
    fork(watchCountryUserRoleSaga),
    fork(watchComponentsStateSaga),
    fork(watchBloodPressureSaga),
    fork(watchGlucometrySaga),
    fork(watchEducationalElementSaga),
    fork(watchEducationalCategorySaga),
    fork(watchPatientEventSaga),
    fork(watchDashboardStaffSaga),
    fork(watchClinicPhonesSaga),
    fork(watchS3FileSaga),
    fork(watchAppointmentsZoomSaga)
  ]);
}
